import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { HistoryServiceController } from './history-service.controller';
import { History } from './history-service.entity';
import { HistoryServiceService } from './history-service.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([History]),
  ],
  controllers: [HistoryServiceController],
  providers: [HistoryServiceService,ApplicationExceptionHandler]
})
export class HistoryServiceModule {}
